<template>
    <div class="el-col el-col-11"> 
        <el-select v-model="selSexs" placeholder="全部">
            <el-option v-for="item in sexs" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>
<script>
import { Select} from 'element-ui'

export default {
  name: 'app',
    components: {
        Select
    },
    data () {
        return {
            // 对象属性
            sexs:[{
                'value':'',
                'name':'全部',
            },{
                'value':'男',
                'name':'男',
            },{
                'value':'女',
                'name':'女',
            }],
            selSexs:''
        }
    },
    props:{
        selSexs:{
            type:String,
            default:''
        }
    },
    watch:{
        selSexs(val){
                this.$emit('update:value', val)        
        }
    },  
    methods:{
    }
}
</script>
<style>
    .el-popper[x-placement^=bottom] .popper__arrow{
        left:50% !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/reports/codeCom/sex.vue?dcfa4ec8